<template>
  <LegalSection />
</template>

<script>
import LegalSection from "@/components/LegalSection.vue";

export default {
  inheritAttrs: false,
  components: {
    LegalSection,
  },
};
</script>

<style lang="scss"></style>
